import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import { Country, State } from "country-state-city";
import { gethospital } from "../../services/admin/hospital/hospital";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { Link, useParams, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { updatedoctor } from "../../services/admin/doctor/doctor";
import { useMessageApi } from "../../services/message api/MessageProvider";

const EditDoctor = () => {
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [country, setCountry] = useState();
  const [statevalue, setStateValue] = useState();

  useEffect(() => {
    const states = State.getStatesOfCountry("IN");
    const formattedStates = states?.map((state) => ({
      label: state.name,
      value: state.name,
    }));
    const options = Country.getAllCountries()?.map((country) => ({
      label: country.name,
      value: country.name,
    }));
    setCountry(options);
    setStateValue(formattedStates);
  }, []);

  const location = useLocation();
  const { doctor } = location.state || {}; // fallback in case state is missing
  console.log("doctor", doctor);

  const id = doctor?.id;

  // State for form data
  const [formData, setFormData] = useState({
    hospital: "",
    firstName: "",
    lastName: "",
    middleName: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    gender: "",
    designation: "",
    qualification: "",
    doctor_types: [],
  module_permissions: [],
    speciality: "",
    mciRegistrationNumber: "",
    dateOfBirth: "",
    address: "",
    city: "",
    country: "",
    state: "",
    postalCode: "",
  });
const doctorTypeOptions = [
  { id: 1, name: "Pediatrics" }, { id: 2, name: "Internal Medicine" },
  { id: 3, name: "General Practice" }, { id: 4, name: "Cardiology" },
  { id: 5, name: "Urology" }, { id: 6, name: "Diabetology" },
  { id: 7, name: "Pulmonology" }, { id: 8, name: "Gastroenterology" },
  { id: 9, name: "Dermatology" }, { id: 10, name: "Endocrinology" },
  { id: 11, name: "Gynaecology" }, { id: 12, name: "E.N.T." },
  { id: 13, name: "Orthopedics" }, { id: 14, name: "Psychiatry" },
  { id: 15, name: "Neurology" }, { id: 16, name: "Nephrology" },
  { id: 17, name: "Dentistry" }, { id: 18, name: "Oncology" },
  { id: 19, name: "Hematology" }
].map(item => ({ label: item.name, value: item.id }));

const moduleOptions = [
  { id: 1, name: "Consult" }, { id: 2, name: "Vaccination" },
  { id: 3, name: "Check-up" }, { id: 4, name: "Certificates" },
  { id: 5, name: "Growth" }, { id: 6, name: "Investigations" },
  { id: 7, name: "Fitness" }, { id: 8, name: "Procedures" },
  { id: 9, name: "OBGYN" }, { id: 10, name: "Patient Timeline" },
  { id: 11, name: "Upload" }
].map(item => ({ label: item.name, value: item.id }));
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (doctor) {
      setFormData({
        hospital: doctor.hospital || "",
        firstName: doctor.Name || "",
        status: doctor.status ? doctor.status.toLowerCase() : "active",
        parentID: doctor.parentId || "",
        lastName: doctor.lastname || "",
        middleName: doctor.middlename || "",
        mobile: doctor.mobile || "",
        email: doctor.Email || "",
        doctor_types: doctor.doctor_types || [],
        module_permissions: doctor.module_permissions || [],
        password: doctor.password || "",
        confirmPassword: doctor.password || "", // Assuming same as password for edit
        gender: doctor.gender ? doctor.gender.toLowerCase() : "",
        designation: doctor.designation || "",
        qualification: doctor.qualification || "",
        speciality: doctor.speciality || "",
        mciRegistrationNumber: doctor.mci_registration_number || "",
        dateOfBirth: doctor.date_of_birth || "",
        address: doctor.address || "",
        city: doctor.city || "",
        country: doctor.country || "",
        state: doctor.state || "",
        postalCode: doctor.pincode || "",
      });
    }
    console.log("doctor form", doctor);
  }, []);

  const [hospital, setHospital] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const fetchHospitals = async () => {
    try {
      const result = await gethospital();
      console.log("Hospital data:", result);
      const options = result?.data?.map((hospital) => ({
        label: hospital.name,
        value: hospital.id,
      }));
      setHospital(options);
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };

  useEffect(() => {
    fetchHospitals();
  }, []);

  const onChange = (date, dateString) => {
    setIsClicked(true);
    handleChange(date.toISOString().split("T")[0], "dateOfBirth");
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.hospital) {
      newErrors.hospital = "Hospital is required";
    }
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleChange = (eventOrValue, fieldName) => {
  setFormData((prevData) => {
    let newData = { ...prevData };

    if (eventOrValue?.target) {
      const { name, value } = eventOrValue.target;
      newData[name] = value;
    } else if (fieldName) {
      if (Array.isArray(eventOrValue)) {
        // Multi-select: user_modules
        newData[fieldName] = eventOrValue.map((opt) => ({
          id: opt.value,
          name: opt.label,
        }));
      } else if (eventOrValue && typeof eventOrValue === "object") {
        // Single-select: doctor_types
        newData[fieldName] = 
          {
            id: eventOrValue.value,
            name: eventOrValue.label,
          }
        ;
      } else {
        newData[fieldName] = eventOrValue || (fieldName === 'doctor_types' || fieldName === 'module_permissions' ? [] : "");
      }
    }
    return newData;
  });
};

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: "topRight", // <-- key part for right side
  });
const messageApi = useMessageApi();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsClicked(true);

      const payload = {
        parent_user_id: formData.hospital?.id,
        name: formData.firstName,
        middle_name: formData.middleName, // Changed from middleName to match typical API conventions
        last_name: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        password: formData.password,
        designation: formData.designation,
        qualification: formData.qualification,
        speciality: formData.speciality,
        mci_registration_number: formData.mciRegistrationNumber,
        date_of_birth: formData.dateOfBirth,
        doctor_types: formData.doctor_types,
        module_permissions: formData.module_permissions,
        gender: formData.gender,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        pincode: formData.postalCode,
        status: formData.status,
      };

      try {
        const result = await updatedoctor(id, payload);
        if (result.success) {
          messageApi.open({
            type: "success",
            content: "Doctor updated successfully",
          });
          navigate("/doctorlist");
          console.log("ds", payload);
          console.log("id:", id);
        } else {
          console.error("Update failed:", result.error);
          Object.entries(result?.error).forEach(([field, messages]) => {
            messages.forEach((msg) => {
              messageApi.open({
                type: "error",
                content: `${field}: ${msg}`,
                style: {
                  maxWidth: "300px",
                  minWidth: "300px",
                  textAlign: "left",
                  wordBreak: "break-word",
                  marginLeft: "auto",
                  marginRight: "0",
                },
              });
            });
          });
        }
      } catch (err) {
        console.error("Failed to update doctor:", err);
        messageApi.open({
          type: "error",
          content: "Failed to update doctor. Please try again.",
        });
      }
    }
  };
  const handleCancel = () => {
    navigate("/doctorlist");
  };
  const customSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused
        ? "none"
        : "2px solid rgba(46, 55, 164, 0.1)",
      boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
      "&:hover": {
        borderColor: state.isFocused
          ? "none"
          : "2px solid rgba(46, 55, 164, 0.1)",
      },
      borderRadius: "10px",
      fontSize: "14px",
      minHeight: "45px",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
      transition: "250ms",
      width: "35px",
      height: "35px",
    }),
  };

  // if (isLo) return <div>Loading...</div>;
  // if (isError) return <div>Error loading doctor data</div>;

  return (
    <div>
      <Header />
      <Sidebar activeClassName="doctor" />
      <div className="page-wrapper">

        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/doctorlist">Doctors </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Edit Doctor</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Doctor Details</h4>
                        </div>
                      </div>
                      <div className="col-12 col-md-13 col-xl-12">
                        <div className="form-group local-forms">
                          <label>
                            Select Hospital{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <Select
                            menuPosition="fixed"
                            name="hospital"
                            value={
                              hospital.find(
                                (option) => option.label === formData.hospital.name
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, "hospital")
                            }
                            options={hospital}
                            menuPortalTarget={document.body}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "#2e37a4"
                                  : "rgba(46, 55, 164, 0.1)",
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #2e37a4"
                                  : "none",
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                            }}
                          />

                          {errors.parent_user_id && (
                            <p style={{ color: "red" }}>
                              {errors.parent_user_id}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            First Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="firstName"
                            type="text"
                            placeholder=""
                            value={formData.firstName}
                            onChange={handleChange}
                          />
                          {errors.firstName && (
                            <p style={{ color: "red" }}>{errors.firstName}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>Middle Name</label>
                          <input
                            className="form-control"
                            name="middleName"
                            type="text"
                            placeholder=""
                            value={formData.middleName}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Last Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="lastName"
                            type="text"
                            placeholder=""
                            value={formData.lastName}
                            onChange={handleChange}
                          />
                          {errors.lastName && (
                            <p style={{ color: "red" }}>{errors.lastName}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Mobile <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="mobile"
                            type="text"
                            placeholder=""
                            value={formData.mobile}
                            onChange={handleChange}
                          />
                          {errors.mobile && (
                            <p style={{ color: "red" }}>{errors.mobile}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="email"
                            type="email"
                            placeholder=""
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <p style={{ color: "red" }}>{errors.email}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Password</label>
                          <input
                            className="form-control"
                            name="password"
                            type="password"
                            placeholder="leave blank to keep current password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                          {errors.password && (
                            <p style={{ color: "red" }}>{errors.password}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Confirm Password </label>
                          <input
                            className="form-control"
                            name="confirmPassword"
                            type="password"
                            placeholder="enter confirm password "
                            value={formData.confirmPassword}
                            onChange={handleChange}
                          />
                          {errors.confirmPassword && (
                            <p style={{ color: "red" }}>
                              {errors.confirmPassword}
                            </p>
                          )}
                        </div>
                      </div>
                      {/* Doctor Type */}
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Doctor Type</label>
                          <Select
                            options={doctorTypeOptions}
                            value={
                              formData.doctor_types?.map((t) => ({
                                label: t.name,
                                value: t.id,
                              }))[0] || null
                            }
                            onChange={(val) =>
                              handleChange(val, "doctor_types")
                            }
                            styles={customSelectStyles}
                            menuPortalTarget={document.body}
                          />
                        </div>
                      </div>

                      {/* Modules */}
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Module</label>
                          <Select
                            isMulti
                            options={moduleOptions}
                            value={formData.module_permissions?.map((m) => ({
                              label: m.name,
                              value: m.id,
                            }))}
                            onChange={(val) =>
                              handleChange(val, "module_permissions")
                            }
                            styles={customSelectStyles}
                            menuPortalTarget={document.body}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Designation</label>
                          <input
                            className="form-control"
                            name="designation"
                            type="text"
                            placeholder=""
                            value={formData.designation}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Qualification</label>
                          <input
                            className="form-control"
                            name="qualification"
                            type="text"
                            placeholder=""
                            value={formData.qualification}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Speciality</label>
                          <input
                            className="form-control"
                            name="speciality"
                            type="text"
                            placeholder=""
                            value={formData.speciality}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>MCI Registration Number</label>
                          <input
                            className="form-control"
                            name="mciRegistrationNumber"
                            type="text"
                            placeholder=""
                            value={formData.mciRegistrationNumber}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms cal-icon">
                          <label>Date Of Birth</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            value={
                              formData.dateOfBirth
                                ? dayjs(formData.dateOfBirth)
                                : null
                            }
                            onChange={onChange}
                            format="YYYY-MM-DD"
                            style={{
                              borderColor: isClicked
                                ? "#2E37A4"
                                : "2px solid rgba(46, 55, 164, 0.1)",
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group select-gender">
                          <label className="gen-label">Gender</label>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                name="gender"
                                onChange={handleChange}
                                value="male"
                                checked={formData.gender === "male" || null}
                                className="form-check-input"
                              />
                              Male
                            </label>
                          </div>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                onChange={handleChange}
                                value="female"
                                name="gender"
                                checked={formData.gender === "female" || null}
                                className="form-check-input"
                              />
                              Female
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group select-gender">
                          <label className="gen-label">
                            Status<span className="login-danger">*</span>
                          </label>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                name="status"
                                onChange={handleChange}
                                value="active"
                                checked={formData.status === "active"}
                                className="form-check-input"
                              />
                              Active
                            </label>
                          </div>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                onChange={handleChange}
                                value="Deactivate"
                                checked={formData.status === "Deactivate"}
                                name="status"
                                className="form-check-input"
                              />
                              Deactivate
                            </label>
                          </div>
                          {errors.status && (
                            <p style={{ color: "red" }}>{errors.status}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12">
                        <div className="form-group local-forms">
                          <label>Address</label>
                          <textarea
                            className="form-control"
                            name="address"
                            onChange={handleChange}
                            rows={3}
                            cols={30}
                            value={formData.address}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>City</label>
                          <input
                            className="form-control"
                            name="city"
                            type="text"
                            value={formData.city}
                            placeholder=""
                            onChange={handleChange}
                          />
                          {errors.city && (
                            <p style={{ color: "red" }}>{errors.city}</p>
                          )}
                        </div>
                      </div>

                      {/* State Select */}
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>State</label>
                          <Select
                            menuPosition={"fixed"}
                            name="state"
                            value={
                              statevalue?.find(
                                (option) => option.value === formData.state
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, "state")
                            }
                            options={statevalue}
                            placeholder="Select State"
                            menuPortalTarget={document.body}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={customSelectStyles}
                          />
                          {errors.state && (
                            <p style={{ color: "red" }}>{errors.state}</p>
                          )}
                        </div>
                      </div>

                      {/* Country Select */}
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>Country</label>
                          <Select
                            menuPosition={"fixed"}
                            name="country"
                            value={
                              country?.find(
                                (option) => option.value === formData.country
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, "country")
                            }
                            options={country}
                            placeholder="Select Country"
                            menuPortalTarget={document.body}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={customSelectStyles}
                          />
                          {errors.country && (
                            <p style={{ color: "red" }}>{errors.country}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Postal Code</label>
                          <input
                            name="postalCode"
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={formData.postalCode}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary cancel-form"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDoctor;
